import React, {FC, ReactNode} from 'react';
import './style.scss';
import classNames from 'classnames';

interface BaseButton {
    children: ReactNode,
    onClick?: () => any,
    isDisabled?: boolean,
    isActive?: boolean,
    isIntroButton?: boolean,
    withBorderRadius?: boolean,
    isFullWidth?: boolean,
    isSizeL?: boolean,
    isButtonCircle?: boolean,
    isLikeButton?: boolean,
    isGreenButton?: boolean,
    isRedButton?: boolean,
    isMixesListButton?: boolean,
    sizePadding?: string,
    sizeBorderRadius?: number,
    isPreferenceButton?: boolean,
    isMixCard?: boolean,
    isFullSize?: boolean
}

const BaseButton: FC<BaseButton> = ({
                                        onClick,
                                        isDisabled,
                                        isActive,
                                        children,
                                        isIntroButton,
                                        withBorderRadius,
                                        isSizeL,
                                        isFullWidth,
                                        isButtonCircle,
                                        isLikeButton,
                                        isRedButton,
                                        isGreenButton,
                                        isMixesListButton,
                                        sizePadding,
                                        sizeBorderRadius,
                                        isPreferenceButton,
                                        isMixCard,
                                        isFullSize
                                    }) => {
    return (
        <button
            onClick={onClick}
            disabled={isDisabled}
            style={{padding: sizePadding, borderRadius: `${sizeBorderRadius}px`}}
            className={classNames({
                'button': true,
                'button--size-l': isSizeL,
                'button--like': isLikeButton,
                'button--circle': isButtonCircle,
                'button--intro': isIntroButton,
                'button--green': isGreenButton,
                'button--red': isRedButton,
                'button--list-mixes': isMixesListButton,
                'button--preferences': isPreferenceButton,
                'button--active': isActive,
                'button--full-width': isFullWidth,
                'button--disabled': isDisabled,
                'button--border-radius': withBorderRadius,
                'button--mix-card': isMixCard,
                'button--full-size': isFullSize,
            })}
        >
            {children}
        </button>
    );
};

export default BaseButton;
